import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { EllipsisVerticalIcon, EyeIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { ProjectCardMenuProps } from "../projectCard.types";

export function ProjectCardMenu({ projectId, onDelete, isDeleting }: ProjectCardMenuProps) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 text-raro-gray-400 hover:text-raro-gray-600 rounded-lg hover:bg-raro-gray-50 transition-colors">
        <EllipsisVerticalIcon className="w-5 h-5" />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-20">
          <div className="py-2">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to={`/projects/${projectId}`}
                  className={clsx(
                    "flex items-center px-4 py-2 text-sm transition-colors",
                    active ? "bg-raro-gray-50 text-raro-gray-900" : "text-raro-gray-700"
                  )}
                >
                  <EyeIcon className="w-4 h-4 mr-3 text-raro-gray-500" />
                  Ver Detalhes
                </Link>
              )}
            </Menu.Item>
            
            <Menu.Item>
              {({ active }) => (
                <Link
                  to={`/projects/${projectId}/edit`}
                  className={clsx(
                    "flex items-center px-4 py-2 text-sm transition-colors",
                    active ? "bg-raro-gray-50 text-raro-gray-900" : "text-raro-gray-700"
                  )}
                >
                  <PencilIcon className="w-4 h-4 mr-3 text-raro-gray-500" />
                  Editar
                </Link>
              )}
            </Menu.Item>

            <div className="border-t border-raro-gray-100 my-1" />
            
            <Menu.Item disabled={isDeleting}>
              {({ active }) => (
                <button
                  onClick={onDelete}
                  disabled={isDeleting}
                  className={clsx(
                    "flex items-center w-full px-4 py-2 text-sm transition-colors",
                    active && !isDeleting ? "bg-red-50 text-red-700" : "text-red-600",
                    isDeleting && "opacity-50 cursor-not-allowed"
                  )}
                >
                  <TrashIcon className="w-4 h-4 mr-3" />
                  {isDeleting ? "Deletando..." : "Deletar"}
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}